import { html, raw } from '../lib/html.js';
import { toast } from '../lib/ui.js';
import { GOOGLE_ERRORS, google } from '../services/google.js';
import { session } from '../services/session.js';
import { me } from '../services/me.js';
import { Page, brand, go } from './base.js';

/**
 * Volta do login com Google: /entrar?c=<código de uso único> ou /entrar?erro=<motivo>.
 * Troca o código pelos tokens e segue para o destino de sempre (completar cadastro ou início).
 */
class GoogleReturnPage extends Page {
  template() {
    return html`
      <ion-content class="ion-padding auth">
        <div class="auth-wrap">
          ${raw(brand('Entrando com Google…'))}
          <div class="google-wait"><ion-spinner name="crescent"></ion-spinner></div>
        </div>
      </ion-content>`;
  }

  async onEnter() {
    google.closeBrowser();
    const q = new URLSearchParams(location.search);
    const code = q.get('c');
    const error = q.get('erro');
    // não deixa o código no histórico (voltar/recarregar não tenta de novo)
    try {
      history.replaceState(history.state, '', location.pathname);
    } catch {
      /* ignore */
    }
    if (!code) {
      if (error || !session.isLoggedIn) toast(GOOGLE_ERRORS[error] ?? GOOGLE_ERRORS.falhou, 'danger', 5000);
      return go(session.isLoggedIn ? '/' : '/login', 'root');
    }
    try {
      const r = await google.exchange(code);
      session.signInWithTokens(r);
      await me.load({ force: true }).catch(() => {});
      go('/', 'root');
    } catch (err) {
      toast(err.message, 'danger', 5000);
      go('/login', 'root');
    }
  }
}

customElements.define('page-google-return', GoogleReturnPage);
